import { useQuery } from "@tanstack/react-query";
import { brokeragesApi } from "@/api/brokerages";
import { brokerageKeys } from "./brokerageKeys";

/** Firm-level production + split-ledger rollup for the staff Production tab.
 * Disabled until an id is present. */
export function useBrokerageProduction(id: string | undefined) {
  return useQuery({
    queryKey: brokerageKeys.production(id ?? ""),
    queryFn: () => brokeragesApi.getProduction(id!),
    enabled: !!id,
  });
}
